export default "__VITE_ASSET__DcOxN3cv__"